import ComparisonPage, { CompetitorData } from "@/components/marketing/ComparisonPage";

const competitor: CompetitorData = {
  name: "TheFork",
  slug: "thefork",
  type: "Marketplace internationale",
  hasCommissionPerCover: true,
  hasPriceCeiling: false,
  complexity: "simple",
  targetAudience: "Établissements touristiques",
  focus: "Acquisition clients",
  supportLanguage: "Multilingue",
  commissionPerCoverChf: "Commission par couvert appliquée (montant variable selon la formule)",
  countryOfOrigin: "France (groupe Tripadvisor, États-Unis)",
  websiteUrl: "https://www.thefork.ch",
  whenToChoose: [
    "Tu as une forte stratégie d'acquisition de nouveaux clients",
    "Ton établissement est situé dans une zone touristique",
    "Tu souhaites bénéficier de la notoriété de la marque TheFork / Tripadvisor",
    "Tu acceptes de payer une commission par couvert pour chaque réservation via leur plateforme",
    "Tu cibles une clientèle internationale",
  ],
  pricingDescription:
    "TheFork (groupe Tripadvisor) combine un abonnement mensuel et une commission par couvert sur chaque réservation effectuée via leur plateforme. Les montants exacts varient selon la formule, la région et la visibilité sponsorisée choisie. Ce modèle peut devenir coûteux pour les établissements avec un fort volume de réservations. Tarifs détaillés à demander directement auprès de TheFork.",
  conclusionStrength:
    "les établissements en zone touristique cherchant à attirer une clientèle internationale via une marketplace à forte notoriété",
  // 83 imp / 2 clicks (CTR 2.4%, pos 9). Title accentue le différenciateur clé
  // (commission TheFork vs forfait fixe Piktable) — le pain point n°1 des restos.
  seoTitle: "Alternative TheFork sans commission par couvert : Piktable",
  seoDescription: "TheFork prélève une commission sur chaque réservation, Piktable propose un forfait fixe Suisse. On compare les coûts réels, fonctionnalités, support FR/CH — verdict pour ton restaurant.",
};

const PiktableVsTheFork = () => {
  return <ComparisonPage competitor={competitor} />;
};

export default PiktableVsTheFork;
